module.exports = __webpack_public_path__ + "static/media/PJ330.d41fc83f.jpg";